import { useState, useEffect } from 'react';

const CATEGORIES = [
  { id: 'all', name: '全部书目', icon: 'ri-booklet-line', color: '#7C3AED' },
  { id: 'blockchain-basic', name: '区块链基础', icon: 'ri-links-line', color: '#3B82F6' },
  { id: 'rwa-core', name: 'RWA核心', icon: 'ri-building-2-line', color: '#EF4444' },
  { id: 'defi-finance', name: 'DeFi与金融', icon: 'ri-line-chart-line', color: '#F59E0B' },
  { id: 'regulation', name: '监管合规', icon: 'ri-scales-line', color: '#10B981' },
  { id: 'carbon', name: '碳资产', icon: 'ri-leaf-line', color: '#059669' },
  { id: 'international', name: '国际名著', icon: 'ri-global-line', color: '#0EA5E9' },
];

interface Book {
  id: string;
  title: string;
  author: string;
  publisher: string;
  year: string;
  category: string;
  stars: number;
  level: string;
  levelColor: string;
  tags: string[];
  summary: string;
  keyPoints: string[];
  coverColor: string;
  coverIcon: string;
  suitable: string;
  lang: 'zh' | 'en';
  buyUrl: string;
  buyPlatform: string;
}

const BOOKS: Book[] = [
  // ── 区块链基础 ──
  {
    id: 'b1', title: '区块链革命', author: '唐·塔普斯科特、亚力克斯·塔普斯科特', publisher: '中信出版集团', year: '2016',
    category: 'blockchain-basic', stars: 5, level: '入门必读', levelColor: '#10B981',
    tags: ['区块链概论', '互联网金融', '商业变革'],
    summary: '区块链领域奠基之作。作者系统梳理区块链技术如何颠覆金融、政府、制造业等12个行业，预见性提出"价值互联网"概念，是理解区块链商业逻辑的第一本书。',
    keyPoints: ['价值互联网 vs 信息互联网的本质区别', 'Trust Protocol（信任协议）的商业影响', '区块链颠覆金融业的七大场景', '智能合约改变合约法律体系的深远影响'],
    coverColor: '#1E3A8A', coverIcon: 'ri-global-line', suitable: '区块链零基础的入门者，金融、法律、咨询行业专业人士',
    lang: 'zh', buyUrl: 'https://search.jd.com/Search?keyword=%E5%8C%BA%E5%9D%97%E9%93%BE%E9%9D%A9%E5%91%BD', buyPlatform: '京东',
  },
  {
    id: 'b2', title: '区块链技术指南', author: '邹均、张海宁、唐屹、李磊', publisher: '机械工业出版社', year: '2016（第3版2021）',
    category: 'blockchain-basic', stars: 5, level: '技术经典', levelColor: '#3B82F6',
    tags: ['技术原理', '共识机制', '密码学', '联盟链'],
    summary: '国内最系统的区块链技术教材，被多所高校选为区块链专业课参考书。从密码学基础到共识机制（PoW/PoS/PBFT）全面覆盖，中文技术书籍中罕见的高质量著作。',
    keyPoints: ['哈希函数与Merkle树的数学原理', 'PoW/PoS/PBFT共识机制深度对比', 'Solidity智能合约开发实战', 'Hyperledger Fabric联盟链架构详解'],
    coverColor: '#1D4ED8', coverIcon: 'ri-code-box-line', suitable: '有编程背景的技术人员、区块链开发者',
    lang: 'zh', buyUrl: 'https://search.jd.com/Search?keyword=%E5%8C%BA%E5%9D%97%E9%93%BE%E6%8A%80%E6%9C%AF%E6%8C%87%E5%8D%97', buyPlatform: '京东',
  },
  {
    id: 'b3', title: '白话区块链', author: '蒋勇、文延、嘉文', publisher: '机械工业出版社', year: '2017',
    category: 'blockchain-basic', stars: 4, level: '入门友好', levelColor: '#10B981',
    tags: ['通俗讲解', '技术入门', '无代码'],
    summary: '面向非技术读者的区块链入门读物，用生活化语言解释区块链、比特币、以太坊的核心概念，零技术门槛，大量类比比喻。',
    keyPoints: ['比特币如何做到"不可伪造"', '以太坊与比特币的本质区别', '智能合约用生活语言解释', '代币 vs 虚拟货币的概念辨析'],
    coverColor: '#059669', coverIcon: 'ri-book-open-line', suitable: '完全没有技术背景的商界人士、律师、会计师、政府人员',
    lang: 'zh', buyUrl: 'https://search.jd.com/Search?keyword=%E7%99%BD%E8%AF%9D%E5%8C%BA%E5%9D%97%E9%93%BE', buyPlatform: '京东',
  },
  {
    id: 'b4', title: '精通以太坊：开发智能合约和去中心化应用', author: '安德烈亚斯·安东诺普洛斯、盖文·伍德', publisher: '机械工业出版社', year: '2019',
    category: 'blockchain-basic', stars: 5, level: '技术深度', levelColor: '#8B5CF6',
    tags: ['以太坊', 'EVM', 'Solidity', '智能合约'],
    summary: '以太坊领域最权威的技术书籍，盖文·伍德是以太坊联合创始人、Solidity语言发明者。详解EVM工作原理、ERC标准体系、智能合约安全。',
    keyPoints: ['EVM架构与Gas机制深度解析', 'ERC-20/ERC-721/ERC-1155标准原理与实现', '智能合约安全漏洞类型与防护', 'Web3.js/Ethers.js与以太坊交互'],
    coverColor: '#4F46E5', coverIcon: 'ri-currency-line', suitable: '区块链开发者、希望深入了解ERC标准体系的RWA从业者',
    lang: 'zh', buyUrl: 'https://search.jd.com/Search?keyword=%E7%B2%BE%E9%80%9A%E4%BB%A5%E5%A4%AA%E5%9D%8A', buyPlatform: '京东',
  },
  {
    id: 'b5', title: '区块链与数字经济：国家战略与产业应用', author: '李礼辉', publisher: '中国发展出版社', year: '2020',
    category: 'blockchain-basic', stars: 4, level: '政策研究', levelColor: '#3B82F6',
    tags: ['国家战略', '数字经济', '区块链政策', '金融安全'],
    summary: '前中国银行行长李礼辉的权威著作，从国家战略视角分析区块链技术与数字经济的关系，是理解"为何境内禁止虚拟货币但支持联盟链"这一政策取向的最权威中文参考。',
    keyPoints: ['中国区块链国家战略背景解读', '联盟链"可监管+可信任"的政策吸引力', '数字货币 vs 加密货币的政策边界', '区块链在金融基础设施中的定位'],
    coverColor: '#1E3A8A', coverIcon: 'ri-flag-line', suitable: '政策研究者、希望理解中国监管政策深层逻辑的企业合规团队',
    lang: 'zh', buyUrl: 'https://search.jd.com/Search?keyword=%E5%8C%BA%E5%9D%97%E9%93%BE%E4%B8%8E%E6%95%B0%E5%AD%97%E7%BB%8F%E6%B5%8E%E6%9D%8E%E7%A4%BC%E8%BE%89', buyPlatform: '京东',
  },
  // ── RWA核心 ──
  {
    id: 'r1', title: '真实世界资产（RWA）：下一代金融革命', author: '多位行业专家合编', publisher: '中国金融出版社', year: '2024',
    category: 'rwa-core', stars: 5, level: 'RWA专项', levelColor: '#EF4444',
    tags: ['RWA', '代币化资产', 'STO', '香港监管'],
    summary: '目前中文市场中最专注RWA领域的综合性著作，系统覆盖RWA的法律结构、技术架构、监管框架（香港/新加坡/欧盟/美国）、案例分析。对中国资产跨境RWA化有专章分析，是实务工作者的核心参考工具书。',
    keyPoints: ['RWA发行标准流程（从底层资产到代币上市）', '香港SFC八号文与合规自查清单', 'SPV结构与真实出售法律要件', '主要RWA平台深度对比'],
    coverColor: '#B91C1C', coverIcon: 'ri-building-2-line', suitable: '律师、金融机构从业者、RWA发行方、监管机构人员',
    lang: 'zh', buyUrl: 'https://search.jd.com/Search?keyword=%E7%9C%9F%E5%AE%9E%E4%B8%96%E7%95%8C%E8%B5%84%E4%BA%A7RWA', buyPlatform: '京东',
  },
  {
    id: 'r2', title: '代币化资产的法律框架', author: '朱东来', publisher: '法律出版社', year: '2023',
    category: 'rwa-core', stars: 4, level: '法律实务', levelColor: '#DC2626',
    tags: ['代币化法律', 'STO法律', '资产确权', '监管合规'],
    summary: '国内首部系统论述代币化资产法律框架的专著，深度分析代币化资产的法律定性、所有权确认、跨境流通的法律障碍，以及境内监管政策的合规路径。',
    keyPoints: ['代币化资产的法律定性（证券vs商品vs财产权）', 'SPV架构的法律有效性分析', '境内禁止vs香港合规的法律差异', '智能合约的法律效力认定'],
    coverColor: '#991B1B', coverIcon: 'ri-scales-line', suitable: '律师、合规人员、RWA项目法务团队',
    lang: 'zh', buyUrl: 'https://search.jd.com/Search?keyword=%E4%BB%A3%E5%B8%81%E5%8C%96%E8%B5%84%E4%BA%A7%E6%B3%95%E5%BE%8B', buyPlatform: '京东',
  },
  {
    id: 'r3', title: '香港数字资产监管实务指南', author: '香港金融科技协会', publisher: '三联书店（香港）', year: '2024',
    category: 'rwa-core', stars: 5, level: '香港合规', levelColor: '#F97316',
    tags: ['香港SFC', 'VASP', '持牌经营', 'VA监管'],
    summary: '由香港金融科技协会组织撰写的实务操作指南，详解香港VASP牌照申请流程、SFC持牌条件、OSL/HashKey等平台的运营规范，是进入香港RWA市场的必备工具书。',
    keyPoints: ['香港VASP牌照申请的完整流程与材料清单', 'SFC合规评估的核心指标', '香港OSL/HashKey的服务对比', '境内投资者通过香港参与RWA的合规路径'],
    coverColor: '#C2410C', coverIcon: 'ri-government-line', suitable: '计划在香港开展RWA业务的机构，境外融资法务团队',
    lang: 'zh', buyUrl: 'https://search.jd.com/Search?keyword=%E9%A6%99%E6%B8%AF%E6%95%B0%E5%AD%97%E8%B5%84%E4%BA%A7%E7%9B%91%E7%AE%A1', buyPlatform: '京东',
  },
  {
    id: 'r4', title: 'RWA Tokenisation in Web 3.0 Era', author: 'Shusong Ba、汪扬等', publisher: 'Springer / 香港学界联合出版', year: '2025',
    category: 'rwa-core', stars: 5, level: 'RWA最新专著', levelColor: '#EF4444',
    tags: ['Web3', 'RWA代币化', '稳定币', '跨境结算'],
    summary: '由巴曙松（香港中文大学）、汪扬（香港科技大学副校长）等学界联合出版的RWA综合性专著，从理论到案例全面覆盖RWA与稳定币、跨境结算、监管框架、技术实现等核心内容，是迄今最系统的英文RWA学术专著。',
    keyPoints: ['Web3时代RWA的完整理论框架', '稳定币与RWA的协同关系', '跨境结算效率提升模型', '全球主要监管框架对比（HK/SG/US/EU）'],
    coverColor: '#991B1B', coverIcon: 'ri-earth-line', suitable: '从业者、投资者、政策制定者、国际RWA学者',
    lang: 'en', buyUrl: 'https://www.amazon.com/s?k=RWA+Tokenisation+Web+3.0+Era+Shusong+Ba', buyPlatform: 'Amazon',
  },
  {
    id: 'r5', title: 'RWA与通证化', author: '汪扬、白海峰、朱皓康', publisher: '香港商务印书馆', year: '2024',
    category: 'rwa-core', stars: 5, level: '香港学界权威', levelColor: '#F97316',
    tags: ['香港RWA', '通证经济学', 'Web3理论', 'VASP监管'],
    summary: '香港科技大学副校长汪扬联合撰写的RWA专著，涵盖Web3基础理论、通证经济学、RWA模型设计、香港监管框架，是了解香港RWA发展模式与跨境RWA机制的权威参考书。',
    keyPoints: ['香港VASP制度与RWA合规路径', '通证化资产的法律定性（香港视角）', 'RWA在香港打造亚洲枢纽的战略价值', '内地资产赴港RWA发行的完整路径'],
    coverColor: '#C2410C', coverIcon: 'ri-government-line', suitable: '跨境RWA从业者、香港市场投资者、监管政策研究者',
    lang: 'zh', buyUrl: 'https://search.jd.com/Search?keyword=RWA%E4%B8%8E%E9%80%9A%E8%AF%81%E5%8C%96', buyPlatform: '京东',
  },
  {
    id: 'r6', title: '股币融合', author: '于佳宁等', publisher: '中国金融出版社', year: '2025',
    category: 'rwa-core', stars: 5, level: '前沿理论', levelColor: '#7C3AED',
    tags: ['股币融合', 'DAT', 'RWA', '资本市场重构'],
    summary: 'Uweb校长于佳宁的重磅新作，提出"股币融合"理论——未来资本市场将是股票（传统权益）与代币（数字权益）并行深度融合的体系，RWA是股币融合的核心载体，将重塑全球资本市场基础设施。',
    keyPoints: ['股币融合理论框架：传统权益与数字权益的协同', 'RWA作为股币融合核心载体的机制设计', 'DAT（数字资产代币）的分类与监管边界', '2030年全球资本市场重构路线图'],
    coverColor: '#4C1D95', coverIcon: 'ri-stock-line', suitable: '投资者、政策研究者、企业家、金融机构战略人员',
    lang: 'zh', buyUrl: 'https://search.jd.com/Search?keyword=%E8%82%A1%E5%B8%81%E8%9E%8D%E5%90%88%E4%BA%8E%E4%BD%B3%E5%AE%81', buyPlatform: '京东',
  },
  {
    id: 'r7', title: '链改2.0：从数字资产到RWA', author: '柳志伟、张烽等', publisher: '机械工业出版社', year: '2025',
    category: 'rwa-core', stars: 5, level: '实操手册', levelColor: '#DC2626',
    tags: ['链改', 'RWA操作流程', '风险管理', '国内合规'],
    summary: '由律师张烽等实务专家联合撰写，系统分析RWA的概念、特征、操作流程及风险管理，包含大量中国企业真实案例。是迄今最贴近中国市场实操的RWA工具书，聚焦境内企业如何合规完成资产代币化。',
    keyPoints: ['链改2.0的核心理念：从数字资产到RWA的进化', 'RWA全操作流程（资产遴选→确权→代币化→发行）', '境内企业参与RWA的法律合规要点', '真实案例：供应链、不动产、知识产权RWA实操'],
    coverColor: '#7F1D1D', coverIcon: 'ri-tools-line', suitable: '中国市场从业者、跨境RWA项目方、法律合规人员',
    lang: 'zh', buyUrl: 'https://search.jd.com/Search?keyword=%E9%93%BE%E6%94%B92.0%E4%BB%8E%E6%95%B0%E5%AD%97%E8%B5%84%E4%BA%A7%E5%88%B0RWA', buyPlatform: '京东',
  },
  // ── DeFi与金融 ──
  {
    id: 'd1', title: 'DeFi与Web3：未来金融的架构', author: '坎贝尔·哈维、阿什温·拉马钱德兰、乔伊·桑托罗', publisher: '机械工业出版社', year: '2022',
    category: 'defi-finance', stars: 5, level: 'DeFi核心', levelColor: '#F59E0B',
    tags: ['DeFi', 'AMM', '借贷', 'DAO', 'RWA'],
    summary: '杜克大学金融教授Harvey与DeFi协议创始人联合撰写，是学术性与实践性最平衡的DeFi权威教材，深度覆盖AMM、借贷、稳定币、治理、RWA等所有核心DeFi模块。',
    keyPoints: ['Uniswap AMM的数学原理（恒定乘积公式）', 'MakerDAO稳定币机制与RWA抵押品策略', 'RWA进入DeFi的风险收益模型', 'MEV（矿工可提取价值）对用户的影响'],
    coverColor: '#D97706', coverIcon: 'ri-line-chart-line', suitable: '金融从业者、DeFi协议分析师、RWA投资决策者',
    lang: 'zh', buyUrl: 'https://search.jd.com/Search?keyword=DeFi+Web3+%E6%9C%AA%E6%9D%A5%E9%87%91%E8%9E%8D', buyPlatform: '京东',
  },
  {
    id: 'd2', title: '代币经济：区块链技术在商业中的实际应用', author: '艾米拉·埃利萨（Shermin Voshmgir）', publisher: '人民邮电出版社', year: '2020',
    category: 'defi-finance', stars: 4, level: '商业视角', levelColor: '#10B981',
    tags: ['代币经济学', 'NFT', '代币设计', 'Web3商业'],
    summary: '维也纳区块链中心创始人的重要著作，系统梳理代币经济学的理论框架，从货币理论到代币设计，从DAO治理到NFT商业模型，对RWA权利代币化设计提供清晰分析框架。',
    keyPoints: ['代币 vs 货币 vs 资产的根本区别', '权利的代币化：三种代币类型的经济含义', '代币激励机制设计原则', 'DAO治理的优劣与RWA适用性'],
    coverColor: '#065F46', coverIcon: 'ri-coins-line', suitable: '商业策略人员、RWA代币结构设计者、DAO治理研究者',
    lang: 'zh', buyUrl: 'https://search.jd.com/Search?keyword=%E4%BB%A3%E5%B8%81%E7%BB%8F%E6%B5%8E', buyPlatform: '京东',
  },
  {
    id: 'd3', title: '区块链金融：理论与实践', author: '张健', publisher: '机械工业出版社', year: '2019',
    category: 'defi-finance', stars: 4, level: '金融应用', levelColor: '#3B82F6',
    tags: ['区块链金融', '供应链金融', '跨境支付', '数字货币'],
    summary: '聚焦区块链在金融业的落地应用，涵盖供应链金融、跨境支付、票据清算、保险等场景，对理解联盟链在境内金融业的真实应用有重要参考价值。',
    keyPoints: ['供应链金融区块链解决方案（应收账款多级流转）', '跨境汇款区块链改造（vs SWIFT传统模式）', '区块链票据与资产证券化的融合路径', '境内联盟链合规要求与备案流程'],
    coverColor: '#1E40AF', coverIcon: 'ri-bank-line', suitable: '银行、保险、供应链金融从业者',
    lang: 'zh', buyUrl: 'https://search.jd.com/Search?keyword=%E5%8C%BA%E5%9D%97%E9%93%BE%E9%87%91%E8%9E%8D%E7%90%86%E8%AE%BA%E4%B8%8E%E5%AE%9E%E8%B7%B5', buyPlatform: '京东',
  },
  // ── 监管合规 ──
  {
    id: 'c1', title: '证券型代币与数字资产监管', author: '多位法律专家合编', publisher: '法律出版社', year: '2023',
    category: 'regulation', stars: 5, level: '合规必读', levelColor: '#EF4444',
    tags: ['STO监管', '法律合规', '香港监管', '美国SEC'],
    summary: '由香港、新加坡、美国执业律师共同撰写的证券型代币监管权威指南，深度比较香港SFC、新加坡MAS、美国SEC对STO/RWA的监管要求。',
    keyPoints: ['香港SFC 1号通函与2023年修订版合规要求', '美国Reg D 506(c)与Reg S境外豁免对比', '新加坡MAS数字代币服务指南', 'RWA跨境发行的法律冲突与选择准据法'],
    coverColor: '#7F1D1D', coverIcon: 'ri-scales-line', suitable: '律师、合规官、RWA发行方的法务团队',
    lang: 'zh', buyUrl: 'https://search.jd.com/Search?keyword=%E8%AF%81%E5%88%B8%E5%9E%8B%E4%BB%A3%E5%B8%81%E6%95%B0%E5%AD%97%E8%B5%84%E4%BA%A7%E7%9B%91%E7%AE%A1', buyPlatform: '京东',
  },
  {
    id: 'c2', title: '数字人民币：e-CNY与货币未来', author: '穆长春', publisher: '中国金融出版社', year: '2021',
    category: 'regulation', stars: 4, level: '政策权威', levelColor: '#10B981',
    tags: ['数字人民币', 'e-CNY', 'CBDC', '货币政策'],
    summary: '中国人民银行数字货币研究所所长穆长春撰写，是理解中国数字人民币政策意图、技术路线、货币理论的权威原著。',
    keyPoints: ['e-CNY "两层运营体系"的设计逻辑', 'e-CNY与稳定币、比特币的根本区别', '批发型CBDC与零售型CBDC的应用场景划分', '人行为何明确区分e-CNY与虚拟货币'],
    coverColor: '#14532D', coverIcon: 'ri-government-line', suitable: '理解中国货币政策、CBDC与RWA关系的政策研究者和金融机构',
    lang: 'zh', buyUrl: 'https://search.jd.com/Search?keyword=%E6%95%B0%E5%AD%97%E4%BA%BA%E6%B0%91%E5%B8%81%E7%A9%86%E9%95%BF%E6%98%A5', buyPlatform: '京东',
  },
  // ── 碳资产 ──
  {
    id: 'ca1', title: '碳中和与碳资产管理', author: '曾少军', publisher: '机械工业出版社', year: '2022',
    category: 'carbon', stars: 4, level: '碳资产专项', levelColor: '#10B981',
    tags: ['碳市场', 'CCER', '碳中和', '碳资产管理'],
    summary: '系统梳理中国碳交易市场运行机制，涵盖碳配额的分配、登记、交易与注销全流程，深度分析CCER项目开发流程与碳资产价值评估方法，是碳资产RWA化的基础参考。',
    keyPoints: ['全国碳市场（CEA）与自愿减排市场（CCER）的制度差异', 'CCER项目开发：备案→核查→签发全流程', '碳价形成机制与碳资产估值方法', '碳资产区块链存证与RWA化的技术路径'],
    coverColor: '#166534', coverIcon: 'ri-leaf-line', suitable: '碳资产项目开发者、希望将碳信用代币化的RWA从业者',
    lang: 'zh', buyUrl: 'https://search.jd.com/Search?keyword=%E7%A2%B3%E4%B8%AD%E5%92%8C%E4%B8%8E%E7%A2%B3%E8%B5%84%E4%BA%A7%E7%AE%A1%E7%90%86', buyPlatform: '京东',
  },
  {
    id: 'ca2', title: '碳交易实务手册', author: '北京绿色金融研究院', publisher: '中国环境出版集团', year: '2023',
    category: 'carbon', stars: 5, level: '实务工具书', levelColor: '#EF4444',
    tags: ['碳交易', 'CCER', 'VCS', 'Gold Standard', '碳核查'],
    summary: '最新版碳交易实务操作手册，覆盖国内CCER与国际VCS、Gold Standard等碳信用体系的方法学，附有碳核查报告填写模板、项目注册流程图，是碳资产RWA发行前"底层资产确权"阶段的操作指南。',
    keyPoints: ['VCS/Gold Standard与CCER的互认问题', 'Verra平台碳信用注册与注销操作', '碳核查（MRV）第三方机构选择标准', '国际碳信用代币化（Toucan/KlimaDAO）案例分析'],
    coverColor: '#14532D', coverIcon: 'ri-recycle-line', suitable: '碳资产管理人员、碳核查机构、碳信用RWA代币发行项目团队',
    lang: 'zh', buyUrl: 'https://search.jd.com/Search?keyword=%E7%A2%B3%E4%BA%A4%E6%98%93%E5%AE%9E%E5%8A%A1%E6%89%8B%E5%86%8C', buyPlatform: '京东',
  },
  // ── 国际名著 ──
  {
    id: 'i1', title: 'The Bitcoin Standard', author: 'Saifedean Ammous', publisher: 'Wiley', year: '2018',
    category: 'international', stars: 5, level: '国际经典', levelColor: '#0EA5E9',
    tags: ['Bitcoin', '货币理论', '硬通货', '奥地利经济学'],
    summary: 'The most comprehensive economic analysis of Bitcoin, arguing Bitcoin is the hardest form of money ever created. Essential reading for understanding the monetary theory behind all cryptocurrency and RWA. Translated into 25+ languages, bestseller in 40+ countries.',
    keyPoints: ['Austrian economics and the theory of sound money', 'Why Bitcoin\'s fixed supply makes it superior to fiat', 'Stock-to-flow model as a valuation framework', 'Implications for global monetary order and RWA settlement'],
    coverColor: '#0369A1', coverIcon: 'ri-currency-line', suitable: '经济学背景的从业者，理解加密资产货币理论基础',
    lang: 'en', buyUrl: 'https://www.amazon.com/s?k=The+Bitcoin+Standard+Saifedean+Ammous', buyPlatform: 'Amazon',
  },
  {
    id: 'i2', title: 'Mastering Bitcoin (2nd Edition)', author: 'Andreas M. Antonopoulos', publisher: "O'Reilly Media", year: '2017',
    category: 'international', stars: 5, level: '技术圣经', levelColor: '#0EA5E9',
    tags: ['Bitcoin技术', '密码学', '区块链原理', '开发者'],
    summary: 'The definitive technical guide to Bitcoin and blockchain. Explains the full stack from cryptographic primitives to Bitcoin scripting, mining, wallets, and network protocols. Open-sourced on GitHub with 10M+ readers. Foundation for understanding all subsequent blockchain technology.',
    keyPoints: ['SHA-256 hashing and ECDSA digital signatures from scratch', 'UTXO model vs account model (Ethereum)', 'Bitcoin Script and multi-signature transactions', 'Lightning Network payment channels (2nd ed addition)'],
    coverColor: '#0C4A6E', coverIcon: 'ri-terminal-box-line', suitable: '技术开发者、希望从底层理解区块链的工程师',
    lang: 'en', buyUrl: 'https://www.amazon.com/s?k=Mastering+Bitcoin+Antonopoulos', buyPlatform: 'Amazon',
  },
  {
    id: 'i3', title: 'The Infinite Machine', author: 'Camila Russo', publisher: 'HarperCollins', year: '2020',
    category: 'international', stars: 4, level: '以太坊传记', levelColor: '#8B5CF6',
    tags: ['以太坊历史', 'Vitalik', 'DeFi起源', '区块链叙事'],
    summary: 'The most compelling narrative account of Ethereum\'s creation — from Vitalik Buterin\'s teenage vision to the DAO hack, ICO boom, and DeFi emergence. Written by former Bloomberg journalist and Defiant founder Camila Russo, reads like a Silicon Valley thriller.',
    keyPoints: ['How a 19-year-old Vitalik Buterin conceived Ethereum', 'The DAO hack of 2016 and Ethereum Classic fork decision', 'How ERC-20 standard accidentally created the ICO bubble', 'The seeds that grew into today\'s DeFi and RWA ecosystem'],
    coverColor: '#4C1D95', coverIcon: 'ri-history-line', suitable: '希望从叙事角度理解以太坊发展史，了解区块链创始背景',
    lang: 'en', buyUrl: 'https://www.amazon.com/s?k=The+Infinite+Machine+Camila+Russo', buyPlatform: 'Amazon',
  },
  {
    id: 'i4', title: 'DeFi and the Future of Finance', author: 'Campbell R. Harvey, Ashwin Ramachandran, Joey Santoro', publisher: 'Wiley', year: '2021',
    category: 'international', stars: 5, level: 'DeFi权威', levelColor: '#0EA5E9',
    tags: ['DeFi', 'AMM', 'Yield Farming', 'RWA抵押品'],
    summary: 'Duke University finance professor Harvey and DeFi protocol founders analyze the systemic flaws of traditional finance and how DeFi solves them. Chapter on RWA collateral (MakerDAO\'s real-world assets strategy) is essential reading for any RWA practitioner.',
    keyPoints: ['5 structural failures of traditional finance DeFi solves', 'AMM constant product formula and impermanent loss math', 'MakerDAO\'s RWA collateral onboarding process', 'Risk management frameworks for DeFi-RWA hybrid protocols'],
    coverColor: '#164E63', coverIcon: 'ri-bank-line', suitable: 'DeFi协议分析师、RWA投资决策者、量化金融研究者',
    lang: 'en', buyUrl: 'https://www.amazon.com/s?k=DeFi+Future+Finance+Campbell+Harvey', buyPlatform: 'Amazon',
  },
  {
    id: 'i5', title: 'Token Economy (2nd Edition)', author: 'Shermin Voshmgir', publisher: 'BlockchainHub Berlin', year: '2020',
    category: 'international', stars: 4, level: '代币设计', levelColor: '#8B5CF6',
    tags: ['Token Economics', 'DAO', 'NFT', 'Web3设计'],
    summary: 'Free open-source book by the founder of Vienna\'s Blockchain Hub. The most comprehensive academic-yet-practical framework for token economics design — covering money theory, DAO governance, NFT, and the token types relevant to RWA (utility vs security vs asset tokens).',
    keyPoints: ['Token vs coin vs currency vs asset: precise definitions', 'Smart contracts as "institutional cryptography"', 'DAO governance design patterns and failure modes', 'How RWA asset tokens differ from utility and security tokens'],
    coverColor: '#3B0764', coverIcon: 'ri-coins-line', suitable: 'RWA代币结构设计者、Web3产品设计师、DAO治理研究者',
    lang: 'en', buyUrl: 'https://www.amazon.com/s?k=Token+Economy+Shermin+Voshmgir', buyPlatform: 'Amazon',
  },
  {
    id: 'i6', title: 'Digital Gold', author: 'Nathaniel Popper', publisher: 'HarperCollins', year: '2015',
    category: 'international', stars: 4, level: '历史叙事', levelColor: '#0EA5E9',
    tags: ['Bitcoin历史', '早期采矿者', '监管冲突', '数字黄金'],
    summary: 'NYT journalist Nathaniel Popper\'s inside account of Bitcoin\'s early years — the Silk Road, Mt.Gox collapse, Winklevoss twins, and the FBI seizure. A gripping journalistic narrative that explains why Bitcoin survived every attack, essential context for today\'s RWA regulatory battles.',
    keyPoints: ['Mt.Gox collapse and the birth of exchange regulation', 'Why FBI\'s Silk Road seizure legitimized Bitcoin globally', 'Winklevoss ETF battle — a template for today\'s RWA approval fights', 'How Bitcoin survived the "cryptocurrency will die" narrative 5 times'],
    coverColor: '#78350F', coverIcon: 'ri-history-line', suitable: '希望了解加密货币历史与监管冲突演进的从业者',
    lang: 'en', buyUrl: 'https://www.amazon.com/s?k=Digital+Gold+Nathaniel+Popper', buyPlatform: 'Amazon',
  },
  {
    id: 'i7', title: 'Cryptoassets: The Innovative Investor\'s Guide', author: 'Chris Burniske & Jack Tatar', publisher: 'McGraw-Hill Education', year: '2017',
    category: 'international', stars: 4, level: '投资框架', levelColor: '#0EA5E9',
    tags: ['加密资产估值', '投资分析', 'Howey Test', '机构配置'],
    summary: 'The first institutional-grade investment framework for crypto assets. Burniske (ARK Invest) classifies crypto into currency/commodity/security tokens and proposes portfolio allocation models — the intellectual foundation for institutional RWA investment decisions today.',
    keyPoints: ['Cryptoasset classification framework (3 types)', 'Applying the Howey Test to different token types', 'Cryptoasset portfolio construction with traditional assets', 'Valuing utility tokens with modified Equation of Exchange'],
    coverColor: '#0C4A6E', coverIcon: 'ri-pie-chart-line', suitable: '机构投资者、资产管理机构、研究RWA投资价值的分析师',
    lang: 'en', buyUrl: 'https://www.amazon.com/s?k=Cryptoassets+Burniske+Tatar', buyPlatform: 'Amazon',
  },
  {
    id: 'i8', title: 'The Fiat Standard', author: 'Saifedean Ammous', publisher: 'Wiley', year: '2021',
    category: 'international', stars: 4, level: '货币批判', levelColor: '#0EA5E9',
    tags: ['法币体系', '通货膨胀', '货币史', '硬资产'],
    summary: 'Ammous\'s sequel to The Bitcoin Standard — a comprehensive critique of the 20th century fiat monetary system. Explains why inflation systematically transfers wealth from workers to asset holders, and why RWA tokenization (by making previously illiquid assets liquid and divisible) is the logical response.',
    keyPoints: ['How the Bretton Woods collapse created modern fiat', 'Inflation as a hidden tax on savings (data from 20 countries)', 'Why time-preference theory predicts demand for hard assets', 'RWA as the "fiat era\'s ultimate exit ramp" — the author\'s thesis'],
    coverColor: '#1C1917', coverIcon: 'ri-money-dollar-circle-line', suitable: '理解RWA宏观叙事的投资者，货币理论研究者',
    lang: 'en', buyUrl: 'https://www.amazon.com/s?k=The+Fiat+Standard+Ammous', buyPlatform: 'Amazon',
  },
  {
    id: 'i9', title: 'Real World Assets: The $16 Trillion Tokenization Opportunity', author: 'Various Authors (BCG × ADDX Research)', publisher: 'Boston Consulting Group', year: '2022',
    category: 'international', stars: 5, level: '行业报告', levelColor: '#EF4444',
    tags: ['RWA市场规模', '资产代币化', '机构研究', 'BCG报告'],
    summary: 'The landmark BCG research report that first quantified the $16 trillion RWA market opportunity by 2030, triggering institutional interest globally. Analyzes asset classes (real estate, private equity, bonds, infrastructure) by tokenization readiness, liquidity uplift, and regulatory pathway.',
    keyPoints: ['$16 trillion market size methodology and assumptions', 'Asset class ranking by tokenization readiness (real estate #1)', 'Liquidity premium calculation for tokenized vs traditional assets', 'Regulatory roadmap by jurisdiction (US/EU/SG/HK)'],
    coverColor: '#7F1D1D', coverIcon: 'ri-file-chart-line', suitable: 'RWA行业从业者、投资机构决策者、政策研究者，最重要的市场规模研究报告',
    lang: 'en', buyUrl: 'https://www.amazon.com/s?k=Real+World+Assets+Tokenization+BCG', buyPlatform: 'Amazon',
  },
  {
    id: 'i10', title: 'How to DeFi: Advanced', author: 'CoinGecko Research Team', publisher: 'CoinGecko', year: '2021',
    category: 'international', stars: 4, level: '进阶实操', levelColor: '#10B981',
    tags: ['DeFi进阶', 'Yield Strategies', '流动性挖矿', 'RWA整合'],
    summary: 'The most practical DeFi manual available — covers advanced yield strategies, MEV, flash loans, cross-chain bridges, and crucially, a dedicated chapter on RWA integration (MakerDAO\'s Centrifuge integration, Maple Finance\'s undercollateralized lending). Required reading for DeFi practitioners.',
    keyPoints: ['Cross-chain bridge risks and the $2B+ bridge hack history', 'Flash loan mechanics and arbitrage strategies', 'Maple Finance\'s undercollateralized RWA lending model', 'Credit assessment frameworks for RWA borrowers in DeFi'],
    coverColor: '#064E3B', coverIcon: 'ri-exchange-line', suitable: 'DeFi操盘手、RWA协议开发者、链上金融策略研究者',
    lang: 'en', buyUrl: 'https://www.amazon.com/s?k=How+to+DeFi+Advanced+CoinGecko', buyPlatform: 'Amazon',
  },
  {
    id: 'i11', title: 'The Web3 Handbook', author: 'Edited by Noah Jessop et al.', publisher: 'Foundation Press', year: '2023',
    category: 'international', stars: 4, level: 'Web3全景', levelColor: '#8B5CF6',
    tags: ['Web3', 'DAO', 'NFT', 'Identity', 'RWA'],
    summary: 'A collection of essays from 30+ Web3 practitioners covering identity, governance, NFTs, DeFi, and RWA. Provides a pluralistic view of the Web3 movement\'s philosophy, covering debates between maximalists and pragmatists on the role of RWA in decentralized finance.',
    keyPoints: ['Web3 identity and reputation systems (Soulbound Tokens)', 'DAO governance failures and lessons from ConstitutionDAO', 'NFT utility beyond art: the RWA connection', 'Institutional DeFi: compliance-first approaches to Web3'],
    coverColor: '#2E1065', coverIcon: 'ri-earth-line', suitable: '希望全面了解Web3生态和RWA在其中定位的从业者',
    lang: 'en', buyUrl: 'https://www.amazon.com/s?k=The+Web3+Handbook', buyPlatform: 'Amazon',
  },
  {
    id: 'i12', title: 'Mastering Ethereum', author: 'Andreas Antonopoulos & Gavin Wood', publisher: "O'Reilly Media", year: '2018',
    category: 'international', stars: 5, level: '以太坊圣经', levelColor: '#4F46E5',
    tags: ['Ethereum', 'EVM', 'ERC标准', '智能合约'],
    summary: 'The definitive technical reference for Ethereum — co-authored by Gavin Wood (Ethereum co-founder, Solidity inventor). Covers EVM architecture, Solidity programming, ERC standards (20/721/1155), and smart contract security. Essential for anyone building RWA token contracts.',
    keyPoints: ['EVM bytecode execution and gas economics', 'Full ERC-20/721/1155 implementation walkthrough', 'Reentrancy, integer overflow, and access control vulnerabilities', 'Layer 2 scaling solutions and their RWA implications'],
    coverColor: '#312E81', coverIcon: 'ri-code-s-slash-line', suitable: '智能合约开发者、RWA代币技术架构师',
    lang: 'en', buyUrl: 'https://www.amazon.com/s?k=Mastering+Ethereum+Antonopoulos+Gavin+Wood', buyPlatform: 'Amazon',
  },
];

const PLATFORM_LOGOS: Record<string, { icon: string; color: string; label: string }> = {
  '京东': { icon: 'ri-shopping-cart-2-line', color: '#E1251B', label: '京东' },
  'Amazon': { icon: 'ri-amazon-line', color: '#FF9900', label: 'Amazon' },
};

type ReadStatus = 'unread' | 'reading' | 'finished';

interface BookNote {
  status: ReadStatus;
  note: string;
  updatedAt: string;
}

const STATUS_CONFIG: Record<ReadStatus, { label: string; color: string; icon: string }> = {
  unread: { label: '未读', color: '#9CA3AF', icon: 'ri-book-line' },
  reading: { label: '在读', color: '#F59E0B', icon: 'ri-book-open-line' },
  finished: { label: '已读', color: '#10B981', icon: 'ri-checkbox-circle-line' },
};

const STORAGE_KEY = 'rwa_book_notes';

function loadNotes(): Record<string, BookNote> {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || '{}');
  } catch {
    return {};
  }
}

function saveNotes(notes: Record<string, BookNote>) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(notes));
}

export default function RWABookshelf() {
  const [activeCategory, setActiveCategory] = useState('all');
  const [expanded, setExpanded] = useState<string | null>(null);
  const [lang, setLang] = useState<'all' | 'zh' | 'en'>('all');
  const [bookNotes, setBookNotes] = useState<Record<string, BookNote>>(loadNotes);
  const [noteModal, setNoteModal] = useState<string | null>(null);
  const [noteText, setNoteText] = useState('');
  const [noteStatus, setNoteStatus] = useState<ReadStatus>('unread');

  useEffect(() => {
    saveNotes(bookNotes);
  }, [bookNotes]);

  const openNoteModal = (bookId: string) => {
    const existing = bookNotes[bookId];
    setNoteText(existing?.note || '');
    setNoteStatus(existing?.status || 'unread');
    setNoteModal(bookId);
  };

  const saveNote = () => {
    if (!noteModal) return;
    setBookNotes((prev) => ({
      ...prev,
      [noteModal]: {
        status: noteStatus,
        note: noteText,
        updatedAt: new Date().toLocaleDateString('zh-CN'),
      },
    }));
    setNoteModal(null);
  };

  const getReadingCount = () => Object.values(bookNotes).filter((n) => n.status === 'reading').length;
  const getFinishedCount = () => Object.values(bookNotes).filter((n) => n.status === 'finished').length;

  const filtered = BOOKS.filter((b) => {
    const catMatch = activeCategory === 'all' || b.category === activeCategory;
    const langMatch = lang === 'all' || b.lang === lang;
    return catMatch && langMatch;
  });

  const renderStars = (count: number) =>
    Array.from({ length: 5 }, (_, i) => (
      <i key={i} className={`${i < count ? 'ri-star-fill text-amber-400' : 'ri-star-line text-gray-300'} text-xs`}></i>
    ));

  return (
    <section id="bookshelf" className="py-20 bg-white">
      <div className="max-w-[1440px] mx-auto px-4 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-[#7C3AED]/10 rounded-full mb-4">
            <i className="ri-booklet-line text-[#7C3AED] text-sm"></i>
            <span className="text-[#7C3AED] text-sm font-semibold">RWA与区块链精选书单</span>
          </div>
          <h2 className="text-3xl lg:text-4xl font-black text-gray-900 mb-4">区块链 &amp; RWA 权威书单</h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            精选{BOOKS.length}部国内外权威著作，涵盖区块链基础、RWA核心、DeFi金融、合规监管、碳资产五大方向，兼收近10年国际名著，每本附购买链接。
          </p>
        </div>

        {/* Stats */}
        <div className="flex flex-wrap gap-3 justify-center mb-8">
          {[
            { num: `${BOOKS.length}`, label: '精选书目', icon: 'ri-book-2-line' },
            { num: `${BOOKS.filter(b => b.lang === 'zh').length}`, label: '中文著作', icon: 'ri-zhihu-line' },
            { num: `${BOOKS.filter(b => b.lang === 'en').length}`, label: '国际名著', icon: 'ri-global-line' },
            { num: `${BOOKS.filter(b => b.stars === 5).length}`, label: '五星推荐', icon: 'ri-star-fill' },
            { num: `${getReadingCount()}`, label: '在读中', icon: 'ri-book-open-line' },
            { num: `${getFinishedCount()}`, label: '已读完', icon: 'ri-checkbox-circle-line' },
          ].map((s) => (
            <div key={s.label} className="bg-gray-50 border border-gray-100 rounded-xl px-4 py-2.5 flex items-center gap-2.5">
              <div className="w-7 h-7 flex items-center justify-center bg-[#7C3AED]/10 rounded-lg">
                <i className={`${s.icon} text-[#7C3AED] text-sm`}></i>
              </div>
              <div>
                <div className="font-black text-gray-900 text-base leading-none">{s.num}</div>
                <div className="text-xs text-gray-500">{s.label}</div>
              </div>
            </div>
          ))}
        </div>

        {/* Category Filters */}
        <div className="flex flex-wrap gap-2 mb-3 justify-center">
          {CATEGORIES.map((cat) => (
            <button
              key={cat.id}
              onClick={() => setActiveCategory(cat.id)}
              className={`px-3.5 py-1.5 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap flex items-center gap-1.5 ${
                activeCategory === cat.id ? 'bg-[#7C3AED] text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              <i className={cat.icon}></i>
              {cat.name}
              <span className="text-xs opacity-70">
                ({cat.id === 'all' ? BOOKS.length : BOOKS.filter((b) => b.category === cat.id).length})
              </span>
            </button>
          ))}
        </div>

        {/* Lang filter */}
        <div className="flex justify-center gap-2 mb-8">
          {[
            { v: 'all', label: '全部语言' },
            { v: 'zh', label: '中文著作' },
            { v: 'en', label: '国际英文' },
          ].map((l) => (
            <button
              key={l.v}
              onClick={() => setLang(l.v as 'all' | 'zh' | 'en')}
              className={`px-3 py-1.5 rounded-lg text-xs font-medium transition-all cursor-pointer whitespace-nowrap ${
                lang === l.v ? 'bg-gray-700 text-white' : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              {l.label}
            </button>
          ))}
        </div>

        {/* Books Grid */}
        <div className="grid md:grid-cols-2 xl:grid-cols-3 gap-4">
          {filtered.map((book) => {
            const isOpen = expanded === book.id;
            const platform = PLATFORM_LOGOS[book.buyPlatform];
            return (
              <div
                key={book.id}
                className={`bg-white border rounded-xl overflow-hidden transition-all ${isOpen ? 'border-[#7C3AED]/35' : 'border-gray-100 hover:border-gray-200'}`}
              >
                {/* Color strip */}
                <div className="h-1 w-full" style={{ background: book.coverColor }}></div>

                <div className="p-4">
                  {/* Book Header */}
                  <div className="flex gap-3 mb-3">
                    <div className="w-12 h-16 rounded-lg flex items-center justify-center shrink-0" style={{ background: book.coverColor }}>
                      <i className={`${book.coverIcon} text-white text-lg`}></i>
                    </div>
                    <div className="min-w-0 flex-1">
                      <div className="flex items-center gap-1.5 mb-1 flex-wrap">
                        <span className="text-[10px] px-1.5 py-0.5 rounded-full font-semibold text-white" style={{ background: book.coverColor + 'CC' }}>{book.level}</span>
                        {book.lang === 'en' && (
                          <span className="text-[10px] px-1.5 py-0.5 rounded-full font-semibold bg-gray-100 text-gray-600">EN</span>
                        )}
                      </div>
                      <h4 className="font-black text-gray-900 text-sm leading-tight mb-0.5 line-clamp-2">《{book.title}》</h4>
                      <div className="text-xs text-gray-500 truncate">{book.author}</div>
                      <div className="text-xs text-gray-400">{book.publisher} · {book.year}</div>
                    </div>
                  </div>

                  {/* Stars + Tags */}
                  <div className="flex items-center justify-between mb-2.5">
                    <div className="flex items-center gap-0.5">{renderStars(book.stars)}</div>
                    <div className="flex flex-wrap gap-1 justify-end">
                      {book.tags.slice(0, 2).map((tag) => (
                        <span key={tag} className="text-[10px] px-1.5 py-0.5 bg-gray-50 text-gray-500 rounded-md">{tag}</span>
                      ))}
                    </div>
                  </div>

                  {/* Summary */}
                  <p className="text-gray-500 text-xs leading-relaxed line-clamp-2 mb-3">{book.summary}</p>

                  {/* Action buttons */}
                  <div className="flex items-center gap-2 flex-wrap">
                    <a
                      href={book.buyUrl}
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium border border-gray-200 text-gray-600 hover:border-gray-300 hover:text-gray-800 transition-all cursor-pointer whitespace-nowrap"
                      onClick={(e) => e.stopPropagation()}
                    >
                      <i className={`${platform.icon} text-xs`} style={{ color: platform.color }}></i>
                      {platform.label}购买
                      <i className="ri-external-link-line text-xs text-gray-400"></i>
                    </a>
                    <button
                      onClick={(e) => { e.stopPropagation(); openNoteModal(book.id); }}
                      className="flex items-center gap-1 py-1.5 px-3 rounded-lg text-xs border cursor-pointer whitespace-nowrap transition-colors"
                      style={
                        bookNotes[book.id]
                          ? { color: STATUS_CONFIG[bookNotes[book.id].status].color, borderColor: `${STATUS_CONFIG[bookNotes[book.id].status].color}40`, background: `${STATUS_CONFIG[bookNotes[book.id].status].color}10` }
                          : { color: '#6B7280', borderColor: '#E5E7EB', background: '#fff' }
                      }
                    >
                      <i className={bookNotes[book.id] ? STATUS_CONFIG[bookNotes[book.id].status].icon : 'ri-edit-line'}></i>
                      {bookNotes[book.id] ? STATUS_CONFIG[bookNotes[book.id].status].label : '记笔记'}
                    </button>
                    <button
                      onClick={() => setExpanded(isOpen ? null : book.id)}
                      className="flex items-center gap-1 py-1.5 px-3 rounded-lg text-xs text-gray-500 hover:text-[#7C3AED] hover:bg-[#7C3AED]/5 border border-gray-100 cursor-pointer whitespace-nowrap transition-colors"
                    >
                      {isOpen ? '收起' : '详情'}
                      <i className={`transition-transform duration-200 ${isOpen ? 'ri-arrow-up-s-line' : 'ri-arrow-down-s-line'}`}></i>
                    </button>
                  </div>
                  {/* Note preview */}
                  {bookNotes[book.id]?.note && (
                    <div className="mt-2 px-3 py-2 rounded-lg text-xs text-gray-500 italic border-l-2" style={{ borderColor: STATUS_CONFIG[bookNotes[book.id].status].color, background: `${STATUS_CONFIG[bookNotes[book.id].status].color}08` }}>
                      <i className="ri-double-quotes-l text-gray-300 mr-1"></i>
                      <span className="line-clamp-2">{bookNotes[book.id].note}</span>
                    </div>
                  )}
                </div>

                {isOpen && (
                  <div className="border-t border-gray-50 px-4 pb-4 pt-3 space-y-3">
                    <div>
                      <div className="text-xs font-bold text-gray-600 mb-1.5 flex items-center gap-1.5">
                        <i className="ri-file-text-line text-gray-400"></i>内容概述
                      </div>
                      <p className="text-gray-600 text-xs leading-relaxed bg-gray-50 rounded-lg p-3">{book.summary}</p>
                    </div>
                    <div>
                      <div className="text-xs font-bold text-gray-600 mb-1.5 flex items-center gap-1.5">
                        <i className="ri-key-2-line text-gray-400"></i>核心知识点
                      </div>
                      <div className="space-y-1.5">
                        {book.keyPoints.map((pt, i) => (
                          <div key={i} className="flex gap-2 items-start">
                            <span className="w-4 h-4 rounded-full flex items-center justify-center shrink-0 mt-0.5 text-white text-[9px] font-bold" style={{ background: book.coverColor + 'CC' }}>{i + 1}</span>
                            <p className="text-xs text-gray-600 leading-relaxed">{pt}</p>
                          </div>
                        ))}
                      </div>
                    </div>
                    <div className="bg-amber-50 border border-amber-100 rounded-lg p-3">
                      <div className="text-xs font-bold text-amber-700 mb-1 flex items-center gap-1">
                        <i className="ri-user-star-line"></i>适合人群
                      </div>
                      <p className="text-xs text-amber-800 leading-relaxed">{book.suitable}</p>
                    </div>
                    <a
                      href={book.buyUrl}
                      target="_blank"
                      rel="nofollow noopener noreferrer"
                      className="flex items-center justify-center gap-1.5 w-full py-2 rounded-lg text-xs font-medium border border-gray-200 text-gray-600 hover:border-[#7C3AED]/30 hover:text-[#7C3AED] transition-all cursor-pointer"
                    >
                      <i className={`${platform.icon} text-xs`} style={{ color: platform.color }}></i>
                      前往{platform.label}查看详情
                      <i className="ri-external-link-line text-xs"></i>
                    </a>
                  </div>
                )}
              </div>
            );
          })}
        </div>

        <div className="mt-6 text-center">
          <p className="text-sm text-gray-400">
            当前显示 <span className="text-[#7C3AED] font-semibold">{filtered.length}</span> / {BOOKS.length} 部书目 · 持续更新中
          </p>
          <p className="text-xs text-gray-400 mt-1">
            购书链接仅供参考，如有链接失效请自行在对应平台搜索书名 · 本站不参与任何销售分成
          </p>
        </div>

        {/* Copyright notice */}
        <div className="mt-6 p-4 bg-gray-50 border border-gray-100 rounded-xl">
          <div className="flex items-start gap-3">
            <i className="ri-copyright-line text-gray-400 text-base shrink-0 mt-0.5"></i>
            <p className="text-gray-500 text-xs leading-relaxed">
              本网站所有原创内容均依据《中华人民共和国著作权法》受到版权保护。未经RWA99.cn书面许可，不得以任何形式使用本站内容。合法引用须注明"来源：RWA99.cn"并附原文链接。
              <strong className="text-gray-600">Copyright © 2025-2026 RWA99.cn. All Rights Reserved.</strong>
            </p>
          </div>
        </div>
      </div>

      {/* Note Modal */}
      {noteModal && (() => {
        const book = BOOKS.find((b) => b.id === noteModal);
        if (!book) return null;
        return (
          <div className="fixed inset-0 z-50 flex items-center justify-center p-4" onClick={() => setNoteModal(null)}>
            <div className="absolute inset-0 bg-black/40 backdrop-blur-sm"></div>
            <div
              className="relative bg-white rounded-2xl w-full max-w-md shadow-2xl"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="px-6 pt-6 pb-4 border-b border-gray-100 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 flex items-center justify-center rounded-xl text-white" style={{ background: book.coverColor }}>
                    <i className={book.coverIcon}></i>
                  </div>
                  <div>
                    <h3 className="font-black text-gray-900 text-sm">阅读笔记</h3>
                    <p className="text-xs text-gray-400 line-clamp-1">《{book.title}》</p>
                  </div>
                </div>
                <button onClick={() => setNoteModal(null)} className="w-8 h-8 flex items-center justify-center rounded-lg text-gray-400 hover:bg-gray-100 cursor-pointer">
                  <i className="ri-close-line text-lg"></i>
                </button>
              </div>
              <div className="px-6 py-5 space-y-4">
                {/* Status */}
                <div>
                  <label className="block text-xs font-bold text-gray-700 mb-2">阅读状态</label>
                  <div className="flex gap-2">
                    {(Object.keys(STATUS_CONFIG) as ReadStatus[]).map((s) => {
                      const cfg = STATUS_CONFIG[s];
                      return (
                        <button
                          key={s}
                          onClick={() => setNoteStatus(s)}
                          className="flex-1 flex items-center justify-center gap-1.5 py-2 rounded-lg text-xs font-bold border transition-all cursor-pointer"
                          style={
                            noteStatus === s
                              ? { background: cfg.color, color: '#fff', borderColor: cfg.color }
                              : { background: '#fff', color: '#6B7280', borderColor: '#E5E7EB' }
                          }
                        >
                          <i className={cfg.icon}></i>
                          {cfg.label}
                        </button>
                      );
                    })}
                  </div>
                </div>
                {/* Note text */}
                <div>
                  <label className="block text-xs font-bold text-gray-700 mb-1.5">读书心得</label>
                  <textarea
                    value={noteText}
                    onChange={(e) => setNoteText(e.target.value.slice(0, 500))}
                    rows={5}
                    maxLength={500}
                    placeholder="记录您的读书心得、重点摘录或个人感悟……（最多500字）"
                    className="w-full border border-gray-200 rounded-lg px-3 py-2 text-sm focus:outline-none focus:border-[#7C3AED]/50 transition-colors resize-none"
                  ></textarea>
                  <div className="text-right text-xs text-gray-400 mt-1">{noteText.length}/500</div>
                </div>
                <div className="flex gap-3">
                  {bookNotes[noteModal] && (
                    <button
                      onClick={() => {
                        setBookNotes((prev) => { const n = { ...prev }; delete n[noteModal]; return n; });
                        setNoteModal(null);
                      }}
                      className="px-4 py-2.5 rounded-xl text-xs font-bold border border-red-100 text-red-400 hover:bg-red-50 cursor-pointer whitespace-nowrap transition-colors"
                    >
                      <i className="ri-delete-bin-line mr-1"></i>删除笔记
                    </button>
                  )}
                  <button
                    onClick={saveNote}
                    className="flex-1 py-2.5 rounded-xl text-sm font-bold text-white cursor-pointer whitespace-nowrap"
                    style={{ background: book.coverColor }}
                  >
                    <i className="ri-save-line mr-1.5"></i>保存笔记
                  </button>
                </div>
              </div>
            </div>
          </div>
        );
      })()}
    </section>
  );
}
